(function () {
  function initGallery(root) {
    if (!root || root.dataset.nekasGalleryReady === 'true') return;
    root.dataset.nekasGalleryReady = 'true';

    const dropdown = root.querySelector('[data-gallery-dropdown]');
    const currentLabel = root.querySelector('[data-gallery-current]');
    const options = Array.from(root.querySelectorAll('[data-gallery-option]'));
    const grid = root.querySelector('[data-gallery-grid]');
    const cards = Array.from(root.querySelectorAll('[data-gallery-card]'));
    const lightbox = root.querySelector('[data-gallery-lightbox]');
    const dialog = root.querySelector('[data-gallery-lightbox-content]');
    const media = root.querySelector('[data-gallery-media]');
    const imageWrap = root.querySelector('[data-gallery-lightbox-image]');
    const close = root.querySelector('[data-gallery-close]');
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    const counter = root.querySelector('[data-gallery-counter]');
    const dots = root.querySelector('[data-gallery-dots]');
    const lightboxHome = lightbox ? lightbox.parentNode : null;
    const lightboxAnchor = lightbox ? lightbox.nextSibling : null;
    let visibleCards = cards;
    let activeSlides = [];
    let activeSlideIndex = 0;
    let lastTrigger = null;
    let touchStartX = null;
    let touchStartY = null;
    let viewportFrame = null;

    function syncLightboxViewport() {
      if (!lightbox) return;
      const header = document.querySelector('.section-header');
      let headerOffset = 0;

      if (header) {
        const rect = header.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          headerOffset = Math.max(0, Math.min(rect.bottom, window.innerHeight));
        }
      }

      lightbox.style.setProperty('--nekas-gallery-header-offset', `${Math.ceil(headerOffset)}px`);
    }

    function queueLightboxViewportSync() {
      if (viewportFrame !== null) window.cancelAnimationFrame(viewportFrame);
      viewportFrame = window.requestAnimationFrame(() => {
        viewportFrame = null;
        syncLightboxViewport();
      });
    }

    function portalLightbox() {
      if (!lightbox || lightbox.parentNode === document.body) return;
      document.body.appendChild(lightbox);
    }

    function restoreLightbox() {
      if (!lightbox || !lightboxHome || !lightboxHome.isConnected) return;
      if (lightboxAnchor && lightboxAnchor.parentNode === lightboxHome) {
        lightboxHome.insertBefore(lightbox, lightboxAnchor);
      } else {
        lightboxHome.appendChild(lightbox);
      }
    }

    function dateScore(card) {
      const raw = (card.dataset.date || '').trim();
      if (!raw) return Number.NEGATIVE_INFINITY;
      const parsed = Date.parse(raw);
      return Number.isNaN(parsed) ? Number.NEGATIVE_INFINITY : parsed;
    }

    function sortNewestFirst() {
      if (!grid || cards.length < 2) return;
      cards.sort((a, b) => dateScore(b) - dateScore(a)).forEach(card => grid.appendChild(card));
    }

    function applyFilter(filter) {
      visibleCards = cards.filter(card => filter === 'all' || card.dataset.category === filter);
      cards.forEach(card => {
        const isVisible = filter === 'all' || card.dataset.category === filter;
        card.hidden = !isVisible;
        card.style.display = isVisible ? '' : 'none';
      });
    }

    function closeDropdown() {
      if (dropdown && dropdown.tagName.toLowerCase() === 'details') dropdown.removeAttribute('open');
    }

    function ensureSlideImage(slide) {
      if (!slide || slide.querySelector('img')) return;
      const src = slide.dataset.src || '';
      if (!src) return;
      const image = document.createElement('img');
      if (slide.dataset.srcset) image.srcset = slide.dataset.srcset;
      image.sizes = '(max-width: 989px) 94vw, 70vw';
      image.src = src;
      image.alt = slide.dataset.alt || 'Gallery image';
      image.decoding = 'async';
      image.loading = 'eager';
      slide.appendChild(image);
    }

    function createFallbackSlide(card) {
      const slide = document.createElement('figure');
      slide.className = 'nekas-gallery-slide';
      slide.dataset.gallerySlide = '';
      const cover = card.querySelector('.nekas-gallery-card__image img');
      const placeholder = card.querySelector('.nekas-gallery-placeholder');
      if (cover) {
        const image = cover.cloneNode(true);
        image.removeAttribute('loading');
        slide.appendChild(image);
      } else if (placeholder) {
        slide.appendChild(placeholder.cloneNode(true));
      }
      return slide;
    }

    function updateDots() {
      if (!dots) return;
      const dotButtons = Array.from(dots.querySelectorAll('button'));
      dotButtons.forEach((dot, index) => {
        const active = index === activeSlideIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function setSlide(index) {
      if (!activeSlides.length) return;
      activeSlideIndex = Math.max(0, Math.min(index, activeSlides.length - 1));
      activeSlides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeSlideIndex;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      ensureSlideImage(activeSlides[activeSlideIndex]);
      ensureSlideImage(activeSlides[activeSlideIndex - 1]);
      ensureSlideImage(activeSlides[activeSlideIndex + 1]);

      if (counter) {
        counter.textContent = `${activeSlideIndex + 1}/${activeSlides.length}`;
        counter.hidden = activeSlides.length < 2;
      }
      if (prev) {
        prev.hidden = activeSlides.length < 2;
        prev.disabled = activeSlideIndex === 0;
      }
      if (next) {
        next.hidden = activeSlides.length < 2;
        next.disabled = activeSlideIndex === activeSlides.length - 1;
      }
      if (dots) dots.hidden = activeSlides.length < 2;
      updateDots();
    }

    function loadSlides(card) {
      if (!imageWrap) return;
      const templateId = card.dataset.gallerySlidesId || '';
      const template = templateId ? document.getElementById(templateId) : null;
      if (template && template.content) imageWrap.replaceChildren(template.content.cloneNode(true));
      else imageWrap.replaceChildren();

      activeSlides = Array.from(imageWrap.querySelectorAll('[data-gallery-slide]'));
      if (!activeSlides.length) {
        imageWrap.appendChild(createFallbackSlide(card));
        activeSlides = Array.from(imageWrap.querySelectorAll('[data-gallery-slide]'));
      }

      if (dots) {
        dots.replaceChildren();
        activeSlides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'nekas-gallery-lightbox__dot';
          dot.setAttribute('aria-label', `Show image ${index + 1} of ${activeSlides.length}`);
          dot.addEventListener('click', () => setSlide(index));
          dots.appendChild(dot);
        });
      }

      setSlide(0);
    }

    function updatePost(card) {
      if (!lightbox) return;
      const title = lightbox.querySelector('[data-gallery-lightbox-title]');
      const category = lightbox.querySelector('[data-gallery-lightbox-category]');
      const date = lightbox.querySelector('[data-gallery-lightbox-date]');
      const description = lightbox.querySelector('[data-gallery-lightbox-description]');
      if (title) title.textContent = card.dataset.title || 'Untitled';
      if (category) category.textContent = card.dataset.categoryLabel || '';
      if (date) date.textContent = card.dataset.date || '';
      if (description) description.textContent = card.dataset.description || '';
      loadSlides(card);
    }

    function openCard(card) {
      if (!lightbox) return;
      lastTrigger = card;
      updatePost(card);
      portalLightbox();
      syncLightboxViewport();
      lightbox.hidden = false;
      if (dialog) dialog.scrollTop = 0;
      const textPanel = lightbox.querySelector('.nekas-gallery-lightbox__text');
      if (textPanel) textPanel.scrollTop = 0;
      document.documentElement.classList.add('nekas-lightbox-open');
      window.requestAnimationFrame(() => {
        syncLightboxViewport();
        if (close) close.focus({ preventScroll: true });
      });
    }

    function closeLightbox() {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      document.documentElement.classList.remove('nekas-lightbox-open');
      activeSlides = [];
      activeSlideIndex = 0;
      if (imageWrap) imageWrap.replaceChildren();
      if (dots) dots.replaceChildren();
      restoreLightbox();
      if (lastTrigger) lastTrigger.focus({ preventScroll: true });
    }

    options.forEach(option => {
      option.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const value = option.dataset.value || 'all';
        const label = option.textContent.trim() || 'All';
        options.forEach(item => item.classList.toggle('is-active', item === option));
        if (currentLabel) currentLabel.textContent = label;
        applyFilter(value);
        closeDropdown();
      });
    });

    cards.forEach(card => card.addEventListener('click', () => openCard(card)));
    if (close) close.addEventListener('click', closeLightbox);
    if (prev) prev.addEventListener('click', () => setSlide(activeSlideIndex - 1));
    if (next) next.addEventListener('click', () => setSlide(activeSlideIndex + 1));

    if (lightbox) {
      lightbox.addEventListener('click', event => {
        if (event.target === lightbox) closeLightbox();
      });
    }
    if (dialog) dialog.addEventListener('click', event => event.stopPropagation());

    if (media) {
      media.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });
      media.addEventListener('touchend', event => {
        if (touchStartX === null || touchStartY === null || !event.changedTouches.length) return;
        const deltaX = event.changedTouches[0].clientX - touchStartX;
        const deltaY = event.changedTouches[0].clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(deltaX) < 50 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
        if (deltaX < 0) setSlide(activeSlideIndex + 1);
        else setSlide(activeSlideIndex - 1);
      }, { passive: true });
    }

    document.addEventListener('click', event => {
      if (dropdown && !dropdown.contains(event.target)) closeDropdown();
    });
    document.addEventListener('keydown', event => {
      if (!lightbox || lightbox.hidden) {
        if (event.key === 'Escape') closeDropdown();
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setSlide(activeSlideIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setSlide(activeSlideIndex + 1);
      } else if (event.key === 'Tab') {
        const focusable = Array.from(lightbox.querySelectorAll('button:not([hidden]):not(:disabled)'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    window.addEventListener('resize', queueLightboxViewportSync, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', queueLightboxViewportSync, { passive: true });
    }

    sortNewestFirst();
    applyFilter('all');
  }

  function boot() {
    document.querySelectorAll('[data-nekas-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
